import React from "react";
import AreaSideButtons from "./AreaSideButtons";
import { Margin } from "@mui/icons-material";

const AreaSectionTitle = ({ title, information, sideButtons, customSideButtons, leftButton, navigatedId, navigation }) => {
    return (
        <div className='area-section-title'>
            <div style={{ display: "flex", flexDirection: "row", gap: "0px" }}>
                {
                    leftButton ? <div style={{ marginRight: "20px" }}>{leftButton}</div> : null
                }
                <h1 className="area-title">{title}</h1>
                {
                    navigation ? <div style={{ display: "flex", flexDirection: "row", padding: "0px 20px" }}> {navigation.map(nav => {
                        return <div key={nav.id}
                            style={{
                                display: "flex",
                                padding: "10px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                textTransform: "uppercase",
                                fontWeight: "700",
                                fontSize: "14px",
                                color: navigatedId == nav.id ? "white" : "var(--carbone)",
                                backgroundColor: navigatedId !== nav.id ? "transparent" : "var(--carbone)"
                            }}
                            onClick={nav.onSelect}
                        >
                            {nav.title}
                        </div>;
                    })}</div> : null
                }

                {information ? <div> { information } </div> : null}
            </div>
            <AreaSideButtons
                sideButtons={sideButtons}
                customSideButtons={customSideButtons}
            />
        </div>
    );
};

export default AreaSectionTitle;
